<img (click)="back()" [src]="'/assets/img/intern/icons/menus/arrow.svg'" alt="arrow" class="btn-back icon md cr-pointer" [class.abs]="abs">